// extracted by mini-css-extract-plugin
export default {"wrapper":"SchemaTree_wrapper__P3k2b","buttonWrapper":"SchemaTree_buttonWrapper__plb0Y","textContainer":"SchemaTree_textContainer__CjbcV"};